<p-card data-cy="order-products-widget">
  <h3 class="my-0" data-cy="title">Review and adjust the quantities below, if necessary.</h3>
  <div class="mt-4 table-full-card-container">
    <p-table [value]="(reorder$ | async)?.items || []" responsiveLayout="stack" id="productItems" data-cy="items-table">
      <ng-template pTemplate="header">
        <tr>
          <th data-cy="order-products-title-header">Products</th>
          <th data-cy="order-products-category-header">Category</th>
          <th data-cy="order-products-quantity-header">Requested Quantity</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr data-cy="order-products-item">
          <td
            data-cy="order-products-item-title"
            class="item-description w-8"
            [ngClass]="{
              'border-none pb-0':
                item.isNoCharge || asWarningControl(itemsForm!.at(i)!.get('quantity')!).warnings?.invalidValue,
              'opacity-70': !itemsForm!.at(i)!.get('quantity')!.value
            }"
          >
            {{ item.description }}
          </td>
          <td
            data-cy="order-products-item-category"
            class="item-category w-4"
            [ngClass]="{
              'border-none pb-0':
                item.isNoCharge || asWarningControl(itemsForm!.at(i)!.get('quantity')!).warnings?.invalidValue,
              'opacity-70': !itemsForm!.at(i)!.get('quantity')!.value
            }"
          >
            <span class="p-column-title" data-cy="order-products-category-header">Category</span>{{ item.category }}
          </td>
          <td
            data-cy="order-products-item-quantity"
            class="pr-8"
            [ngClass]="
              item.isNoCharge || asWarningControl(itemsForm!.at(i)!.get('quantity')!).warnings?.invalidValue
                ? 'border-none pb-0'
                : ''
            "
          >
            <div class="flex align-items-center justify-content-start w-full">
              <app-number-step-input
                [name]="'items-' + i + '-quantity'"
                [control]="asFormControl(itemsForm?.at(i)?.get('quantity')!)"
              ></app-number-step-input>
              <button
                *ngIf="(itemsForm?.at(i)?.get('quantity'))!.value === initialQuantities[i]"
                pButton
                type="button"
                label="Remove"
                class="p-button-text p-button-sm ml-5 remove-button"
                (click)="onRemoveItem(i)"
                [disabled]="item.isNoCharge"
                data-cy="remove-button"
                appClickEvent
                eventName="order_wizard_remove_product"
              ></button>
              <button
                *ngIf="(itemsForm?.at(i)?.get('quantity'))!.value !== initialQuantities[i]"
                pButton
                type="button"
                label="Reset"
                class="p-button-text p-button-sm ml-5 remove-button"
                (click)="onResetItem(i)"
                data-cy="reset-button"
                appClickEvent
                eventName="order_wizard_reset_product_quantity"
              ></button>
            </div>
          </td>
        </tr>
        <tr *ngIf="item.isNoCharge">
          <td colspan="2" class="py-0"></td>
          <td colspan="1" class="py-0 text-left">
            <!-- TODO Handle missing docs items in a future story if needed -->
            <p class="p4 item-quantity-note" data-cy="no-charge-item-note">
              Quantity cannot be adjusted, this is the allowed amount by your insurance.
            </p>
          </td>
        </tr>
        <tr *ngIf="asWarningControl(itemsForm!.at(i)!.get('quantity')!).warnings?.invalidValue">
          <td colspan="3" class="py-0 pr-6 text-left">
            <app-product-item-quantity-warning
              [initExpanded]="true"
              [messageHtml]="asWarningControl(itemsForm!.at(i)!.get('quantity')!).warnings?.invalidValue.message"
            ></app-product-item-quantity-warning>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>
